import type { AxiosError } from 'axios';
import { CibliError } from '../errors/cibli.error';

/**
 * Build a CibliError from an Axios error using a translate function.
 * Supports both code and message from response data for translation key lookup.
 */
export function buildCibliErrorFromAxios(
  error: AxiosError<{ code?: string; message?: string }>,
  translate: (key: string) => string,
): CibliError {
  const data = error.response?.data;
  if (data) {
    const errorCode = data.code;
    const errorKey = errorCode ?? data.message;

    if (errorKey) {
      const translationKey = `errors.${errorKey}`;
      const translatedMessage = translate(translationKey);
      const finalMessage =
        translatedMessage !== translationKey
          ? translatedMessage
          : translate('errors.internal_error');
      return new CibliError(finalMessage, errorCode);
    }
  }

  return new CibliError(translate('errors.internal_error'));
}
